import { Injectable, OnInit } from '@angular/core';

@Injectable()
export class EcomNetworkUtils {
  /*
  *  Description : Naming convention followed like controllname/methodname
  */
  // Get methods
  //public static GET_IP_ADDRESS = 'https://olar.me/api-ip/api/MagnumService/GetUserIPAddress';
  public static GET_IP_ADDRESS = 'https://api.ipgeolocation.io/ipgeo?apiKey=';
  //public static GET_IP_ADDRESS = 'https://localhost:44334/api/MagnumService/GetUserIPAddress';
  public static GET_OLAR_DISCOUNTS = 'Setting/GetOlarDiscounts';
  public static GET_OLAR_DISCOUNTS_DESCRIPTION = 'Setting/GetOlarDiscountsDescription';
  public static GET_SETTING_STORES = 'Setting/GetSettingStores';
  public static GET_SETTINGS_ALL = 'Setting/GetSettings';
  public static GET_CATEGORY_ITEMS = 'Setting/GetCategoryItems';

  public static GET_ITEMS_BY_CATEGORY = 'Setting/GetItemsByCategoryId';

  public static GET_ITEMS_BY_NAME = 'Setting/GetItemsByName';

  public static GET_ITEM_VARIANTS = 'Setting/GetVariants';
  public static GET_ITEMS_FREE_BY_IDS = 'Setting/GetItemsFreeByIds';

  public static GET_ITEMS_UPSELL_BY_IDS = 'Setting/GetItemsUpsell';
  public static GET_DISCOUNTS_BY_LOCATION_ID = 'Setting/GetDiscountsByLocationId';

  public static GET_ENTIRE_DISCOUNTS_BY_LOCATION_ID = 'Setting/GetEntireDiscountsByLocationId';

  public static GET_SURCHARGES_BY_LOCATION_ID = 'Setting/GetSurchargesByLocationId';
  public static GET_ITEM_DETAILS = 'Setting/GetItemDetails';
  public static GET_ITEM_DETAILS_BY_BARCODE = 'Setting/GetItemDetailsByBarcode';
  public static GET_DIETARY_CUSINES = 'Shared/GetDietaryCusines';
  public static GET_PROFILE = 'User/GetUserData';
  public static GET_UPCOMING_RESERVATIONS = 'Orders/GetUpcomingRerservations';
  public static GET_USER_ORDERS = 'Orders/GetUserOrders';
  public static GET_USER_ORDERS_COUNT = 'Orders/GetUpcomingOrderCount';
  public static GET_RESERVATION_STATUS = 'LocationService/GetReservationStatus';
  public static GET_DINEIN_COLLECTION_DELIVERY_STATUS = 'LocationService/GetDineInCollectionDeliveryStatus';

  public static GET_CUTOMER_ORDER_HISTORY = 'LocationService/GetOrderHistoryByCustomer';

  public static GET_CUTOMER_ORDER_DETAIL = 'LocationService/GetOrderDetailsById';
  public static GET_MESSAGE_URL = 'Shared/GetMessageValue';
  public static GET_VOUCHERSLIST = 'Vouchers/GetVouchersList';
  //Get Get available Olar points - Get Method BY Nandish Gowda
  public static GET_OLAR_POINTS = 'Loyalty/GetOlarPoints';
  public static GET_OLAR_SPEND_RULES = 'Loyalty/GetOlarSpendRules';
  public static GET_OLAR_POINTS_HISTORY = 'Loyalty/GetOlarPointsHistory';
  public static GET_MERCHANT_CUSTOMER_LOYALTY = 'Loyalty/GetMerchantCustomerLoyalty';
  public static GET_AREA_QRCODE_DETAILS = 'Setting/GetAreaQrCodeDetails';

  public static GET_OLAR_REWARDS = 'Loyalty/GetRewards';

  public static GET_OLAR_CUSTOMER_LOYALTY = 'Loyalty/GetCustomerLoyalty';

  // Post Methods
  public static POST_SETTINGS_BY_CORDINATES = 'Setting/GetSettingsByCordinates';
  public static POST_GET_LOCATIONS_SETTINGS = 'Setting/GetLocationSettings';
  public static POST_ADD_SERVICE = 'LocationService/AddService';

  public static POST_INSERT_ORDER = 'LocationService/InsertOrder';
  public static POST_ADD_RESERVATION = 'LocationService/AddReservation';
  public static POST_ORDER_STATUS_NOTIFY = 'LocationService/OrderStatusNotify';
  public static POST_IM_HERE_NOTIFY = 'LocationService/ImHereStatusNotify';
  public static POST_ASSISTANCE_NOTIFY = 'LocationService/AssistanceNotify';
  public static POST_GET_ORDER_STATUS = 'LocationService/GetOrderStatus';
  public static POST_ACCEPTING_ORDERS_NOW = 'LocationService/AcceptingOrdersNow';
  public static POST_UPDATE_LOCATION_RATING = 'Orders/UpdateLocationRating';
  public static POST_REGISTER = 'RegisterUser/Register';
  public static POST_VERIFY_OTP = 'RegisterUser/VeriftOtp';
  public static POST_GENERATEKEY = 'ApplicationKeys/GenerateKeys';
  public static POST_LOGIN = 'Login/UserLogin';
  public static POST_AUTHENTICATE = 'Authenticate/AuthenticateRequest';
  public static POST_PROFILE_UPDATE = 'User/SaveUserData';
  public static POST_PROFILE_PASSWORD_CHANGE = 'User/ChangePassword';
  public static POST_USER_EXIST = 'Login/UserExist';
  public static POST_USER_UPDATE_PASSWORD = 'Login/UpdatePassword';
  public static POST_USER_DETAILS_BY_PHONE = 'Login/GetUserDetailsByPhone';
  public static POST_USER_ORDER_COUNT_FOR_DISCOUNT = 'Login/GetUserOrderCount';
  public static POST_PRINT_PREVIEW = 'PrintInvoice/PrintPreview';
  public static POST_SEND_INVOICE = 'PrintInvoice/SendInvoice';
  public static POST_REFER_FRIEND = 'LocationService/ReferFriend';
  public static POST_REFERRED_DETAILS = 'User/GetReferredDetails';
  public static POST_REQUEST_TOKEN = 'RequestToken/GetRequestToken';
  public static POST_REFRESH_TOKEN = 'RequestToken/GetRefreshToken';
  public static POST_USEREXIST_VERIFIED = 'Login/UserExistAndPhoneVerified';
  public static POST_ISVALID_VOUCHERCODE = 'Vouchers/IsValidVoucherCode';
  public static POST_VOUCHERSLIST = 'Vouchers/VouchersList';
  public static POST_VOUCHERCLAIM = 'Vouchers/VoucherClaim';
  public static POST_GOOGLEAPI_TRACK = 'Olar/GoogleApiTrack';
  public static POST_SAVE_USER_ADDRESS = 'User/SaveUserAddress';
  public static POST_GET_USER_ADDRESS = 'User/GetUserAddresses';
  public static POST_JOIN_LOYALTY = 'Loyalty/JoinLoyaltyProgram';

  // new api's
  public static POST_GET_CATEGORIES = 'Setting/GetCategories';
  public static POST_GET_CATEGORY_ITEMS = 'Setting/GetCategoryItems';
  public static POST_GET_QR_SETTINGS = 'Setting/GetSettingByQR';

  public static GET_BASIC_SETTINGS = 'Setting/GetBasicSettings';


  // Azure apis
  public static AZURE_GET_LOCATION_ADDRESS = 'https://atlas.microsoft.com/search/address/reverse/crossStreet/json';
  public static AZURE_POST_DISTANCE_CALCULATE = 'https://atlas.microsoft.com/route/matrix/json'

  // Goget apis
  public static GOGET_POST_TIME_CHECK = 'https://staging-api.goget.my/api/public/v1/jobs/time_check';
  public static GOGET_POST_ON_DEMAND_TIME_CHECK = 'https://staging-api.goget.my/api/public/v1/jobs/on_demand_time_check';
  public static GOGET_POST_LOCATION_CHECK = 'https://staging-api.goget.my/api/public/v1/jobs/location_check';
  public static GOGET_POST_FEE_CHECK = 'https://staging-api.goget.my/api/public/v1/jobs/check_fee';
  public static GOGET_POST_JOB = 'https://staging-api.goget.my/api/public/v1/jobs';
  public static GOGET_GET_JOBDETAILS = 'https://staging-api.goget.my/api/public/v1/jobs';
  public static GOGET_DELETE_JOB = 'https://staging-api.goget.my/api/public/v1/jobs';

  // google apis
  public static G_POST_LOCATION_ADDRESS = "https://maps.googleapis.com/maps/api/geocode/json";
  public static G_GET_USER_LOCATION_DISTANCE = "https://maps.googleapis.com/maps/api/distancematrix/json";

  // cors origin allow url
  public static ALLOW_CORS_ORIGIN = 'https://cors-anywhere.herokuapp.com/';

  // payment urls
  public static POST_PAYMENT_REQUEST = 'https://staging-gateway.revpay.com.my/payment';
  public static POST_PAYMENT_REQWERY = 'https://staging-gateway.revpay.com.my/requery';
  public static POST_PAYMENT_RETURN_URL = 'https://1.32.96.61/mmposecommerce/orderpayments';
  public static POST_PAYMENT_BACKEND_URL = 'https://1.32.96.61/api-pos/api/payments';

  // qr user verify
  // qr user verify
  public static POST_QR_USER_GET_OTP = 'User/QRUserGetOTP';
  public static POST_QR_USER_VERIFY_OTP = 'User/QRUserVerifyOTP';
  public static POST_QR_USER_PASSWORD_UPDATE = 'User/QRUserPasswordUpdate';
  public static POST_FPX_USER_SAVE = 'User/SaveFPXUser';

  public static POST_ORDER_PAYMENT_STATUS = 'Orders/GetUserOrderPaymentStatus';

  public static POST_ORDER_QR_PAYMENT = 'Orders/GetQrPayment';

  public static POST_ORDER_INQUIRY_QR_PAYMENT = 'Orders/InquiryQr';

  public static POST_VERIFY_SOCIAL_USER = 'Login/VerifySocialUser';
  public static SOCIAL_AUTH_FACEBOOK = 'Login/VerifySocialUser';
  public static SOCIAL_AUTH_GOOGLE = 'Login/VerifySocialUser';

  public static SOCIAL_AUTH_GET_USER_BY_PKID = 'Login/GetUserByPkid';

  public static GIFTCARD_GET_ALL = 'Giftcard/GetGiftcards';

  public static GIFTCARD_MAKE_PAYMENT = 'Giftcard/CreateGiftCardPayment';

  public static GIFTCARD_GET_PURCHASED_GIFTCARD = 'Giftcard/GetPurchasedGiftcard';

  public static GIFTCARD_GET_GIFTCARD_STATUS = 'Giftcard/GetGiftcardStatus';

  public static GIFTCARD_CLOSE_PREVIOUS_DAY_OPENED_FLOAT = 'Giftcard/ClosePreviousDayOpenedFloat';

  public static GIFTCARD_CHECK_OPEN_FLOAT_SHIFT = 'Giftcard/CheckOpenFloatShift';

  public static GIFTCARD_SAVE_OPEN_FLOAT_SHIFT = 'Giftcard/SaveOpenFloatShift';

  public static GIFTCARD_INQUIRY_QR = 'Giftcard/InquiryQr';
}
